import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface HashInputTitleProps extends ComponentProps<'h4'> {}
export function HashInputTitle({ className, ...props }: HashInputTitleProps) {
  return (
    <h4
      className={twMerge(
        'text-md text-center font-medium text-bios-secondary lg:text-xl',
        className,
      )}
      {...props}
    />
  )
}
